// 个人信息模块
export default {
    Personal: {
        SetPassword: 'Tetapkan kata laluan',
        PleaseEnterPassword: 'Sila masukkan kata laluan',
        PleaseEnterPasswordAgain: 'Sila masukkan kata laluan sekali lagi',
        ChangePassword: 'Tukar kata laluan',
        PleaseEnterOldPassword: 'Sila masukkan kata laluan lama',
        PleaseEnterOldPassword2: 'Sila masukkan kata laluan lama',
        PleaseEterNewPassword: 'Sila masukkan kata laluan baru',
        PleaseEterNewPassword2: 'Sila masukkan kata laluan baru',
        PleaseEnterNewPasswordAgain: 'Sila masukkan kata laluan baru sekali lagi',
        ModifyAvatar: 'Ubahsuai Avatar',
        LocalUpload: 'Muat naik ',
        LocalUploadTip: 'Format JPG、GIF、PNG、JPEG、BMP sahaja, saiz kurang dariapada 5M',
        EffectPreview: 'Pratonton Efet',
        Pixels: '100*100 piksel',
        UserInformation: 'Maklumat pengguna',
        HeadPortrait: 'Avatar:',
        ReplaceAvatar: 'Tukar Avatar',
        UserName: 'ID Pengguna:',
        EnterUserName: 'Sila masukkan ID pengguna',
        UserNameCanOnlyModifiedOnce: 'ID pengguna hanya boleh diubahsuai sekali sahaja',
        ModifyUserName: 'Ubahsuai ID pengguna',
        NewUsername: 'Name pengguna baru',
        CellPhoneNumber: 'Nombor telefon bimbit:',
        PleaseEnterPhoneNumber: 'Sila masukkan nombor telefon bimbit',
        PleaseBindPhoneNumber: 'Sila mengikatkan nombor telefon bimbit anda untuk penerbitan informasi.',
        UnbindPhoneNumber: 'Lepaskan perikatan nombor telefon bimbit',
        BindPhoneNumber: 'Ikatkan nombor telefon bimbit',
        PleaseEnterYourPhoneNumber: 'Sila masukkan nombor telefon bimbit anda',
        PleaseEnterVerificationCode: 'Sila masukkan kod pengesahan',
        SendVerificationCode: 'Hantar kod pengesahan',
        Resend: 'Hantar sekali lagi',
        Password: 'Kate Laluan：',
        Mailbox: 'Emel：',
        SetUpEmail: 'Tetapkan Emel',
        BindEmail: 'Ikatkan Emel',
        ModifyEmail: 'Ubahsuai emel',
        VerifyEmailAddress: 'Pengesahan alamat emel',
        EmailAddress: 'Alamat emel',
        SendVerificationEmail: 'Hantar emel pengesahan',
        SendEmail: 'Hantar emel',
        SentTo: 'Emel pengesahan telah dihanter ke emel anda',
        PleaseCheckEmail: 'Sila semak emel',
        NoEmailReceived: 'Emel diterima? Sila semak emel sampah atau klik',
        FullName: 'Nama：',
        PleaseEnterYourName: 'Sila masukkan nama anda',
        Address: 'Alamat：',
        PleaseSelectProvince: 'Sila pilih negeri/wilayah',
        PleaseSelectCity: 'Sila pilih bandar',
        PleaseSelectCounty: 'Sila pilih daerah',
        ModifyAddress: 'Ubahsuai alamat',
        PleaseEnterCorrectPhoneNumber: 'Sila masukkan nombor telefon yang sah',
        PhoneNumberCannotEmpty: 'Nombor telefon bimibit tidak boleh dikosongkan!',
        UserNameCannotEmpty: 'ID pengguna tidak boleh dikosongkan!',
        PleaseFillEmailAddress: 'Sila isikan alamat emel',
        PleaseFillCorrectEmailAddress: 'Sila isikan alamat emel yang sah!',
        FileCannotExceed5MB: 'Saiz fail tidak boleh melebihi 5MB，sila pilih lagi!',
        OldPasswordCannotEmpty: 'Kata laluan lama tidak boleh dikosongkan',
        NewPasswordCannotEmpty: 'Kata laluan baru tidak boleh dikosongkan',
        SecondaryPasswordCannotEmpty: 'Kata laluan sekunder tidak boleh dikosongkan',
        PasswordsEnteredDifferent: 'Kata laluan tidak padan!',
        SuccessfullyModified: 'Pengubahsuaian berjaya',
        SuccessfullySet: 'Tetapan berjaya',
        PleaseSelectCityOrCounty: 'Sila pilih bandar/daerah'
    },
  };